const StorySection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
          Our Story
        </h2>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              1996 we began helping banks, credit unions, mortgage companies, home builders and real estate companies start their own financial services businesses.  We have helped thousands of companies develop policies and procedures.
            </p>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              Don't hire a consultant! Many of our clients have hired consultants to develop written policies and procedures.  They pay tens of thousands of dollars to educate the consultant and end up with an incomplete product.  Our products can save you thousands of dollars.
            </p>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              {/* Third paragraph - Your content will go here */}
              Mortgage Moat is the ONLY company that focuses ONLY on mortgage company documentation, and has helped over 8,900 clients in its 29 years in business.
            </p>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              {/* Fourth paragraph - Your content will go here */}
              Our Headquarters are located in Rockville, Maryland.  Our clients are located in all major markets throughout the country.
            </p>
          </div>
          
          {/* Image Block */}
          <div className="relative">
            <div className="aspect-[4/3] bg-gray-200 rounded-lg overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/25113f0e17980c4cc9f006a0cc94f905.jpeg"
                alt="M&T Bank Office Building - Our Headquarters in Rockville, Maryland"
                title="Our Office Building"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
